const localPermissions = {
  // --- Admin permissions --- //
  GET_USER_ADMIN: {
    name: "get_user_admin",
    platform: "admin"
  },
  ADD_USER_ADMIN: {
    name: "add_user_admin",
    platform: "admin"
  },
  EDIT_USER_ADMIN: {
    name: "edit_user_admin",
    platform: "admin"
  },
  DELETE_USER_ADMIN: {
    name: "delete_user_admin",
    platform: "admin"
  },
  ANONYMIZE_USER: {
    name: "anonymize_user",
    platform: "admin"
  },

  // --- Admin manager permissions --- //
  GET_USER: {
    name: "get_user",
    platform: "admin"
  },
  EDIT_USER: {
    name: "edit_user",
    platform: "admin"
  },
  DELETE_USER: {
    name: "delete_user",
    platform: "admin"
  },
  GET_USER_DAM: {
    name: "get_user_dam",
    platform: "admin"
  },
  ADD_USER_DAM: {
    name: "add_user_dam",
    platform: "admin"
  },
  EDIT_USER_DAM: {
    name: "edit_user_dam",
    platform: "admin"
  },
  DELETE_USER_DAM: {
    name: "delete_user_dam",
    platform: "admin"
  },
  GET_KYC: {
    name: "get_kyc",
    platform: "admin"
  },
  VALIDATE_KYC: {
    name: "validate_kyc",
    platform: "admin"
  },
  VALIDATE_MANDATE: {
    name: "validate_mandate",
    platform: "admin"
  },
  ADMIN_CLOSE_MANDATE: {
    name: "admin_close_mandate",
    platform: "admin"
  },
  ADMIN_WITHDRAW_MANDATE: {
    name: "admin_withdraw_mandate",
    platform: "admin"
  },
  ADMIN_INVESTMENT_MANDATE: {
    name: "admin_investment_mandate",
    platform: "admin"
  },
  GET_PLATFORM_FEE: {
    name: "get_platform_fee",
    platform: "admin"
  },
  EDIT_PLATFORM_FEE: {
    name: "edit_platform_fee",
    platform: "admin"
  },
  GET_ADMIN_MANDATE_FEES: {
    name: "get_admin_mandate_fees",
    platform: "admin"
  },
  GET_IDENTITY_DUPLICATE_REVIEW: {
    name: "get_identity_duplicate_review",
    platform: "admin"
  },
  UPDATE_IDENTITY_DUPLICATE_REVIEW: {
    name: "update_identity_duplicate_review",
    platform: "admin"
  },
  GET_REFERRAL_REWARD: {
    name: "get_referral_reward",
    platform: "admin"
  },
  UPDATE_REFERRAL_REWARD: {
    name: "update_referral_reward",
    platform: "admin"
  },
  GET_LEGAL_DOCUMENT: {
    name: "get_legal_document",
    platform: "admin"
  },
  ADD_LEGAL_DOCUMENT: {
    name: "add_legal_document",
    platform: "admin"
  },

  // --- Dam permissions --- //
  ADD_MANDATE: {
    name: "add_mandate",
    platform: "dam"
  },
  EDIT_MANDATE: {
    name: "edit_mandate",
    platform: "dam"
  },
  CLOSE_MANDATE: {
    name: "close_mandate",
    platform: "dam"
  },
  SUBSCRIPTION_MANDATE_USER: {
    name: "subscription_mandate_user",
    platform: "dam"
  },
  WITHDRAW_MANDATE_USER: {
    name: "withdraw_mandate_user",
    platform: "dam"
  },
  DAM_ARBITRAGE_MANDATE: {
    name: "dam_arbitrage_mandate",
    platform: "dam"
  },
  TRADE_MANDATE: {
    name: "trade_mandate",
    platform: "dam"
  },
  GET_MANDATE_FEES: {
    name: "get_mandate_fees",
    platform: "dam"
  },
  GET_DAM_BANK_ACCOUNT: {
    name: "get_dam_bank_account",
    platform: "dam"
  },
  EDIT_DAM_BANK_ACCOUNT: {
    name: "edit_dam_bank_account",
    platform: "dam"
  },
  GET_TRADING_API_KEY: {
    name: "get_trading_api_key",
    platform: "dam"
  },
  EDIT_TRADING_API_KEY: {
    name: "edit_trading_api_key",
    platform: "dam"
  },

  // --- Support permissions --- //
  GET_SUPPORT_TICKET: {
    name: "get_support_ticket",
    platform: "admin"
  },
  CREATE_SUPPORT_TICKET: {
    name: "create_support_ticket",
    platform: "admin"
  },
  EDIT_SUPPORT_TICKET: {
    name: "edit_support_ticket",
    platform: "admin"
  },
  COMMENT_SUPPORT_TICKET: {
    name: "comment_support_ticket",
    platform: "admin"
  },
  MESSAGE_SUPPORT_TICKET: {
    name: "message_support_ticket",
    platform: "admin"
  },

  GET_FAQ: {
    name: "get_faq",
    platform: "admin"
  },
  ADD_FAQ: {
    name: "add_faq",
    platform: "admin"
  },
  EDIT_FAQ: {
    name: "edit_faq",
    platform: "admin"
  },
  DELETE_FAQ: {
    name: "delete_faq",
    platform: "admin"
  },

  // --- Common permissions --- //
  GET_MANDATE: {
    name: "get_mandate",
    platform: "common"
  },
};

export default localPermissions;
